import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { BaseLoader } from '@adex/shared/models/loaders/base-loader'
import { environment } from '../../../environments'


@Injectable({
  providedIn: 'root'
})
export class ModelLoaderService extends BaseLoader {

  constructor(http: HttpClient) {
    super(http, value => `/assets/models/${ value }.json?v=${ environment.version }`, [
      'group_by_columns-form',
      'claim_report_task_filter-form',
      'real_time_analysis_table_columns',
      'post_analysis_task_filter-form',
    ])
  }
}
